<template>
  <div :class="styles">
    <label v-if="!showMoreActivated">{{ text.slice(0, 50) }}</label>
    <span v-if="text.length > 50 && !showMoreActivated">...</span>
    <br v-if="!showMoreActivated" />
    <label
      v-if="!showMoreActivated && text.length > 50"
      class="link-primary"
      @click="showMoreActivated = true"
    >
      {{ $t('wizard-v2.common.show-more') }}</label
    >
    <div v-if="showMoreActivated">
      <label>{{ text }}</label>
      <br />
      <label class="link-primary" @click="showMoreActivated = false">
        {{ $t('wizard-v2.common.show-less') }}</label
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    text: { type: String, default: '' },
    styles: { type: String, default: '' },
  },
  data() {
    return { showMoreActivated: false };
  },
};
</script>
